// Персистентное состояние тумблера 💡 «лучший ход» — общий для всех экранов
// (разбор, зевки, дебюты). Owner-принцип: «если врубил — включен, переживает
// экраны». Хранится в localStorage; по умолчанию ВЫКЛЮЧЕН: в тренажёре зевков
// включённая по умолчанию стрелка раскрывает ответ до попытки.
const KEY = 'cc_show_best';

/** Прочитать сохранённое состояние 💡 (по умолчанию false). */
export function loadShowBest(): boolean {
  try {
    const v = localStorage.getItem(KEY);
    return v === '1';
  } catch {
    return false;
  }
}

/** Сохранить состояние 💡 (переживает переходы между экранами). */
export function saveShowBest(on: boolean): void {
  try {
    localStorage.setItem(KEY, on ? '1' : '0');
  } catch {
    /* webview may block storage */
  }
}
